<template>
  <div class="page-wrapper">
    <EventsManagment @tab="switchTab" v-if="tab_switch == 'management' && $checkPermission('events')"></EventsManagment>
  </div>
</template>
<script>
import EventsManagment from "./EventsManagment.vue";
export default {
  components: {
    EventsManagment,
  },
  data: () => ({
    tab_switch: "management",
  }),
  watch: {
    "$route.params.tab"(tab) {
      if (tab) {
        this.tab_switch = tab;
      } else {
        this.tab_switch = "management";
      }
    },
  },
  mounted() {
    let vm = this;
    if (vm.$route.params.tab) {
      vm.tab_switch = vm.$route.params.tab;
    } else {
      vm.tab_switch = "management";
    }
  },
  methods: {
    switchTab(tab) {
      let vm = this;
      vm.tab_switch = tab;
      vm.$router.push({ name: "s_events", params: { tab: tab } });
    },
  },
};
</script>
<style lang="scss" scoped>
.page-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
}
</style>

